import { useContext } from 'react';
import { InstantCheckoutStatusContext } from '../contexts/instant-checkout-status-context';

export const useInstantCheckoutStatus = () => {
  const context = useContext(InstantCheckoutStatusContext);
  if (!context) {
    throw new Error(
      'useInstantCheckoutStatus must be used within a InstantCheckoutStatus Provider',
    );
  }
  return context;
};
